export default "__VITE_ASSET__D3A5HR_J__"